import { render } from "./JudgeCard.vue?vue&type=template&id=b63d5f9e"
import script from "./JudgeCard.vue?vue&type=script&lang=js"
export * from "./JudgeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__